import {Box, Typography} from '@mui/material';

import {orangeColors} from '../../../../../layouts/theme/designSystem';

export interface Props {
  label: string;
  value: string;
}

export const WorkforceProfileSeniorityLevelTile = ({label, value}: Props) => (
  <Box
    sx={{
      flex: 1,
      minWidth: 0,
      p: 1.5,
      borderRadius: '10px',
      border: `1px solid ${orangeColors[4]}`,
    }}
  >
    <Typography
      variant='caption'
      sx={{
        display: 'block',
        fontWeight: 700,
        letterSpacing: '0.02em',
        textTransform: 'uppercase',
        color: 'text.secondary',
        mb: 0.5,
      }}
    >
      {label}
    </Typography>
    <Typography variant='body2' sx={{fontWeight: 600, lineHeight: 1.4}}>
      {value}
    </Typography>
  </Box>
);
